import { apiRequest } from '@utils/request';
import { JobListing } from 'types/team';

export async function getJobs(): Promise<Map<string, JobListing[]>> {
	const response = await apiRequest.get(`/careers`);
	const jobListings: Array<JobListing> = response.data;

	const jobListingsByDepartment = jobListings.reduce(
		(allDepartments: Map<string, JobListing[]>, jobListing: JobListing) => {
			return allDepartments.set(jobListing.department, [
				...(allDepartments.get(jobListing.department) || []),
				jobListing
			]);
		},
		new Map<string, JobListing[]>()
	);

	const uncategorizedListings: JobListing[] | undefined = jobListingsByDepartment.get('');
	if (uncategorizedListings) {
		jobListingsByDepartment.delete('');
		jobListingsByDepartment.set('Other', uncategorizedListings);
	}

	return jobListingsByDepartment;
}
